export const fontFamilies = {
  heading: 'Frank Ruhl Libre, serif',
  body: 'Inter, sans-serif',
  caption: 'Inter, sans-serif',
};

export const fontWeights = {
  bold: 700,
  medium: 500,
  normal: 400,
};

export const fontSizes = {
  f1: '.75rem',
  f2: '.875rem',
  f3: '1rem',
  f4: '1.12rem',
  f5: '1.25rem',
  f6: '1.375rem',
  f7: '1.5rem',
  f8: '1.875rem',
  f9: '2.25rem',
  f10: '3rem',
  f11: '3.37rem',
  f12: '3.75rem',
};

export const lineHeights = {
  xs: 1,
  sm: 1.2,
  md: 1.4,
  lg: 1.6,
  xl: 1.8,
  xxl: 2,
};

export const typography = {
  fontFamilies,
  fontWeights,
  fontSizes,
  lineHeights,
};
